import Drawer, { Props as DrawerProps } from '../../../../../../../components/Drawer';
import RecordAttendanceDrawerHeader from './RecordAttendanceDrawerHeader';
import RecordAttendanceDrawerStepper from './RecordAttendanceDrawerStepper';
import RecordAttendanceDrawerSteps, { Steps } from './RecordAttendanceDrawerSteps';

export interface RecordAttendanceDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

const RecordAttendanceDrawer = ({ open, onClose }: RecordAttendanceDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <RecordAttendanceDrawerStepper header={<RecordAttendanceDrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => (
          <RecordAttendanceDrawerSteps currentStep={currentStep} goToNextStep={goToNextStep} />
        )}
      </RecordAttendanceDrawerStepper>
    </Drawer>
  );
};

export default RecordAttendanceDrawer;
